import bugsnag from '@bugsnag/js'
var bugsnagClient = bugsnag('ac3e3a46230adf5f3b5845ee84bb2522')

import { render, h } from 'preact';
import { Provider } from 'redux-zero/preact';

import NeoCloud from './components/NeoCloud';
import store from './store';
import './plugins/geoip'

render(
    <Provider store={store}>
        <NeoCloud/>
    </Provider>
    , document.getElementById('widgetbyneo'))